import React, { useState } from 'react';
import BlogItem from './blog-item';
import Pagination from './pagination';
import blogData from '../../../data/blog-data';

const BlogGridMain = ({position}) => {
    const blogItemShow = 6; // Changed to 6 so all your new posts show on page 1
    const [currentPage, setCurrentPage] = useState(0);
    const totalPages = Math.ceil(blogData.length / blogItemShow);
    const startIndex = currentPage * blogItemShow;
    const endIndex = startIndex + blogItemShow;
    const currentBlogItems = blogData.slice(startIndex, endIndex);
    const handleNextPage = () => {
        if (currentPage < totalPages - 1) {
        setCurrentPage(currentPage + 1);
        }
    };
    const handlePrevPage = () => {
        if (currentPage > 0) {
        setCurrentPage(currentPage - 1);
        }
    };

    return (
        <div className="two__columns section-padding-three">
            <div className="container">
                {/* --- NEW HEADING & INTRO SECTION --- */}
                <div className="row mb-50 justify-content-center">
                    <div className="col-lg-8 t-center">
                        <span className="subtitle wow fadeInUp" data-wow-delay=".2s">Blog & News</span>
                        <h2 className="wow fadeInUp mb-20" data-wow-delay=".4s">Latest Updates & Insights</h2>
                        <p className="wow fadeInUp" data-wow-delay=".6s" style={{ fontSize: '18px', color: '#666', lineHeight: '1.8' }}>
                            Stay updated with project highlights, construction updates, infrastructure insights, and company news from Arclight Developers.
                        </p>
                    </div>
                </div>
                {/* ----------------------------------- */}

                <div className="row">
                    <BlogItem currentBlogItems={currentBlogItems} />
                </div>
                <Pagination
                    currentPage={currentPage}
                    handlePrevPage={handlePrevPage}
                    totalPages={totalPages}
                    handleNextPage={handleNextPage}
                    setCurrentPage={setCurrentPage}
                    position={position || "center"}
                />
            </div>
        </div>
    );
};

export default BlogGridMain;